import './Toaster.css';

import { Toaster as RHToaster } from 'react-hot-toast';

import { CheckCircle, CrossCircle } from '../Icons';

const TOASTER_ICON_SIZE = 24;

export const Toaster: typeof RHToaster = (props) => (
  <RHToaster
    containerClassName="toaster-container"
    toastOptions={{
      className: 'toaster',
      success: {
        className: 'toaster toaster-success',
        icon: <CheckCircle size={TOASTER_ICON_SIZE} />,
      },
      error: {
        className: 'toaster toaster-error',
        icon: <CrossCircle size={TOASTER_ICON_SIZE} />,
      },
      duration: 5000,
    }}
    {...props}
  />
);
